"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSettings = exports.fetchSettingsIfNeeded = exports.UPDATE_SETTINGS = exports.FETCH_SETTINGS = void 0;
var utils_1 = require("../../utils");
exports.FETCH_SETTINGS = (0, utils_1.networkActionTypes)("FETCH_SETTINGS");
exports.UPDATE_SETTINGS = (0, utils_1.networkActionTypes)("UPDATE_SETTINGS");
var fetchSettings = (0, utils_1.networkAction)(exports.FETCH_SETTINGS, "/settings");
exports.fetchSettingsIfNeeded = (0, utils_1.makeIfNeededAction)(fetchSettings, "settings");
var updateSettings = function (settingsData, accessToken) {
    return function (dispatch, getState) {
        if (getState().settings.isFetching || getState().settings.isUpdating)
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_SETTINGS, "/settings", "PUT")(settingsData, {}, accessToken));
    };
};
exports.updateSettings = updateSettings;
